//
//  AmwellExperience.Web
//  MyHealth+
//
//  Created by jinyeob kim on 1/23/20.
//  Copyright © 2020 Facebook. All rights reserved.
//

import { EventEmitter } from 'services/EventEmitter';
import { VisitType, VisitStep } from './client/types';
import { Visit } from './sdk/types';

export const amwellBus = new EventEmitter();

/**
 * Use these static methods to listen for changes during visit waiting room in web app.
 */
export class Amwell {
  static visitChange(cb: (visit: Visit, type: VisitType, step: VisitStep) => void) {
    amwellBus.on('visitChange', ({ visit, type, step }) => cb(visit, type, step));
  }
  static visitLeave() {
    amwellBus.off('visitChange');
  }
}
